import React from 'react';
import './common-modal.scss';
import closeIcon from '../../static/close.svg';
function CommonModal({ enableCloseButton = true, ...props }) {
    return (
        <>
            <div className="common-modal-backdrop"></div>
            <div id='popUp' tabIndex='0' className={"common-modal-container "+(props.className || '')}>
                { enableCloseButton && <img src={closeIcon} className="close" alt="close icon" role="button" onClick={() => props.onClose()}/> }
                <div className="content-container">
                    {props.children}
                </div>
            </div>
        </>
    );
}

export default CommonModal;